import { useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import EudrDashboardService from 'src/modules/3rd-party-management/apis/admin/EudrDashboardService';

export const EUDR_GEOLOCATION_DATA_QUERY_KEY = '3rd-party-management-fetch-eudr-geolocation-data';

const useGeolocationData = ({
    supplierId,
    t,
}) => {
    return useQuery({
        queryKey: [EUDR_GEOLOCATION_DATA_QUERY_KEY, supplierId],
        queryFn: async () => {
            const service = EudrDashboardService.getInstance();

            return await service.fetchGeolocationData({
                supplierId,
            });
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        enabled: !!supplierId,
        onError: (error) => {
            if (process.env.NODE_ENV === 'development') console.error(error);

            toast(t('An error occurred while fetching geolocation data.'), {
                type: 'error',
            });
        },
    });
};

export default useGeolocationData;
